import React from "react";
import {
  MapPin,
  Music,
  Mountain,
  Plane,
  Bus,
  Info,
  Camera,
  Hotel, // Nuevo icono
} from "lucide-react";
import "../css/loja.css";
import lojaimagen from "../img/ingenieria/loja.png";
import puerta from "../img/ingenieria/puerta.png";
import catedral from "../img/ingenieria/catedral.png";
import museo from "../img/ingenieria/museo.png";
import jipiro from "../img/ingenieria/jipiro.png";
import saraguro from "../img/ingenieria/saraguro.png";
import podocarpus from "../img/ingenieria/podocarpues.jpg";
import vilca from "../img/ingenieria/vilca.png";

const atractivosCiudad = [
  {
    title: "Puerta de la Ciudad",
    desc: "Monumento emblemático y salas de exposición.",
    imagen: puerta,
  },
  {
    title: "Centro Histórico",
    desc: "Arquitectura republicana y plazas coloniales.",
    imagen: catedral,
  },
  {
    title: "Museo de la Música",
    desc: "Tradición musical lojana en un solo lugar.",
    imagen: museo,
  },
  {
    title: "Parque Jipiro",
    desc: "Recreación y réplicas arquitectónicas del mundo.",
    imagen: jipiro,
  },
];

// Nueva data de hoteles
const hotelesLoja = [
  { nombre: "Sonesta Hotel Loja", zona: "Ciudadela Zamora", tel: "258-9000", web: "sonestaloja.com", cat: "4★ – negocios" },
  { nombre: "Casa Bolívar Hotel-Museo", zona: "Centro Histórico", tel: "2570344", web: "lojaecuador.com.ec", cat: "4★" },
  { nombre: "Grand Victoria Boutique Hotel", zona: "Centro histórico", tel: "258-3500", web: "grandvictoriabh.com", cat: "Boutique – alta gama" },
  { nombre: "Oro Verde Loja", zona: "18 de Noviembre y Eguiguren", tel: "Consultar web", web: "oroverdeloja.com", cat: "4★ – moderno" },
  { nombre: "Hotel Podocarpus", zona: "Centro", tel: "258-4912", web: "hotelpodocarpus.com.ec", cat: "Categoría media" },
  { nombre: "Hotel Libertador", zona: "Centro", tel: "257-0344", web: "—", cat: "Tradicional" },
  { nombre: "Hotel Villonaco", zona: "Centro", tel: "Consultar", web: "hotelvillonaco.com", cat: "Categoría media" },
  { nombre: "Hotel San Sebastián", zona: "Av. 18 de Noviembre", tel: "Consultar", web: "sansebastianloja.com", cat: "Categoría media" },
  { nombre: "Hotel Virgen del Cisne", zona: "Centro", tel: "Consultar", web: "—", cat: "Económico" },
  { nombre: "Hotel Saraguro", zona: "Av. Universitaria", tel: "Consultar", web: "hotelsaraguroloja.com", cat: "Económico" },
];

const Loja = () => {
  const style = {
    backgroundImage: `url(${lojaimagen})`,
  };

  return (
    <div className="loja-container">
      {/* Hero Section */}
      <header className="loja-hero" style={style}>
        <div className="hero-overlay">
          <h1>Loja</h1>
          <p className="subtitle">Capital Cultural y Musical del Ecuador</p>
          <div className="badge-container">
            <span className="badge">Segura</span>
            <span className="badge">Ordenada</span>
            <span className="badge">Andina</span>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="loja-content">
        <section className="section layout9">
          <h2>
            <Camera size={24} /> Atractivos en la ciudad
          </h2>
          <div className="grid-cards">
            {atractivosCiudad.map((item, index) => (
              <div key={index} className="card">
                <img src={item.imagen} alt={item.title}></img>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="section surroundings ">
          <h2 className="layout9">
            <Mountain size={24} /> Experiencias en alrededores
          </h2>
          <div className="surroundings-list">
            <div className="s-item">
              <img src={podocarpus} alt="Podocarpus"></img>
              <div className="s-item-content">
                <p>
                  <b>Podocarpus: </b>
                </p>
                <p> Bosques nublados y cascadas.</p>
              </div>
            </div>
            <div className="s-item">
              <img src={vilca} alt="Vilcabamba"></img>
              <div className="s-item-content">
                <p>
                  {" "}
                  <b>Vilcabamba:</b>
                </p>{" "}
                <p> El famoso Valle de la Longevidad.</p>
              </div>
            </div>
            <div className="s-item">
              <img src={saraguro} alt="Saraguro"></img>{" "}
              <div className="s-item-content">
                <p>
                  <b>Saraguro:</b>
                </p>{" "}
                <p> Tradiciones vivas y artesanía auténtica.</p>
              </div>
            </div>
          </div>
        </section>

        {/* --- NUEVA SECCIÓN DE HOTELES --- */}
        <section className="section hotels-section layout9">
          <h2>
            <Hotel size={24} /> Hoteles en la ciudad de Loja
          </h2>
          <p className="section-intro">
            Listado referencial de diferentes categorías. Se recomienda confirmar tarifas y disponibilidad con antelación.
          </p>
          <div className="table-container">
            <table className="hotels-table">
              <thead>
                <tr>
                  <th>Hotel</th>
                  <th>Zona / Dirección</th>
                  <th>Teléfono (+593)</th>
                  <th>Web / contacto</th>
                  <th>Categoría / notas</th>
                </tr>
              </thead>
              <tbody>
                {hotelesLoja.map((h, i) => (
                  <tr key={i}>
                    <td data-label="Hotel"><b>{h.nombre}</b></td>
                    <td data-label="Zona">{h.zona}</td>
                    <td data-label="Teléfono">{h.tel}</td>
                    <td data-label="Web">
                      {h.web !== "—" ? (
                        <a href={`https://${h.web}`} target="_blank" rel="noreferrer">{h.web}</a>
                      ) : "—"}
                    </td>
                    <td data-label="Categoría">{h.cat}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        <section className="section transport">
          <h2 className="layout9">
            <Plane size={24} /> Cómo Llegar
          </h2>
          <div className="transport-grid layout9">
            <div className="transport-card">
              <Plane size={20} />
              <p>
                Vía aérea al Aeropuerto Catamayo (LOH) + 45 min vía terrestre.
              </p>
            </div>
            <div className="transport-card">
              <Bus size={20} />
              <p>Rutas desde Quito (11h), Guayaquil (7h) o Piura, Perú (8h).</p>
            </div>
          </div>
        </section>

        <section className="tips-banner">
          <h3>
            <Info size={20} /> Tips de Viaje
          </h3>
          <ul>
            <li>Lleva efectivo para mercados locales.</li>
            <li>Documentación vigente (Cédula/Pasaporte).</li>
            <li>Ropa para clima variable (Andino).</li>
          </ul>
        </section>
      </main>
    </div>
  );
};

export default Loja;